import { render, staticRenderFns } from "./DataAddItem.vue?vue&type=template&id=2c5d3016&scoped=true"
import script from "./DataAddItem.vue?vue&type=script&lang=js"
export * from "./DataAddItem.vue?vue&type=script&lang=js"
import style0 from "./DataAddItem.vue?vue&type=style&index=0&id=2c5d3016&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d3016",
  null
  
)

export default component.exports